// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_page {
    display: flex;
    flex-direction: row;
    height: 100vh; /* ocupar toda la altura de la pantalla */
}`, "",{"version":3,"sources":["webpack://./src/styles/main_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa,EAAE,yCAAyC;AAC5D","sourcesContent":[".main_page {\n    display: flex;\n    flex-direction: row;\n    height: 100vh; /* ocupar toda la altura de la pantalla */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
